var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mr-plan-header" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 24, md: 24 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t("dateRange.dateRange"),
                                    placement: "top",
                                  },
                                },
                                [
                                  _vm.viewType === "daily"
                                    ? _c("el-date-picker", {
                                        staticClass: "highlighted-input",
                                        attrs: {
                                          type: "daterange",
                                          clearable: false,
                                          "start-placeholder": _vm.$t(
                                            "dateRange.startDate"
                                          ),
                                          "end-placeholder":
                                            _vm.$t("dateRange.endDate"),
                                          "picker-options": {
                                            firstDayOfWeek: 7,
                                          },
                                          "value-format": "yyyy-MM-dd",
                                        },
                                        on: {
                                          change: _vm.handleDateRangeChanges,
                                        },
                                        model: {
                                          value: _vm.dateRange,
                                          callback: function ($$v) {
                                            _vm.dateRange = $$v
                                          },
                                          expression: "dateRange",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.viewType === "weekly"
                                    ? _c("el-date-picker", {
                                        ref: "week",
                                        staticClass: "highlighted-input",
                                        attrs: {
                                          type: "week",
                                          clearable: false,
                                          placeholder: _vm.$t("dateRange.week"),
                                          format:
                                            _vm.$t("dateRange.week") + " WW",
                                        },
                                        on: { change: _vm.handleWeekChanges },
                                        model: {
                                          value: _vm.weekNum,
                                          callback: function ($$v) {
                                            _vm.weekNum = $$v
                                          },
                                          expression: "weekNum",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.viewType === "monthly"
                                    ? _c("el-date-picker", {
                                        ref: "month",
                                        staticClass: "highlighted-input",
                                        attrs: {
                                          type: "monthrange",
                                          clearable: false,
                                          placeholder:
                                            _vm.$t("dateRange.month"),
                                        },
                                        on: { change: _vm.handleMonthChanges },
                                        model: {
                                          value: _vm.monthRange,
                                          callback: function ($$v) {
                                            _vm.monthRange = $$v
                                          },
                                          expression: "monthRange",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.$props.type === "manual"
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled: _vm.isManualAssignLoading,
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "planning.placeholder.plateNumber"
                                        ),
                                      },
                                      on: {
                                        change: _vm.handleSelectedTruckChanges,
                                      },
                                      model: {
                                        value: _vm.$selectedTruck,
                                        callback: function ($$v) {
                                          _vm.$selectedTruck = $$v
                                        },
                                        expression: "$selectedTruck",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: null },
                                      }),
                                      _vm._l(
                                        _vm.$trucks,
                                        function (truck, index) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: truck.id,
                                              attrs: {
                                                label: truck.plateNumber,
                                                value: truck.id,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(truck.plateNumber)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(truck.vehicleType)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$props.type === "manual"
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c("el-tooltip", [
                                    _vm.isAssignToTruckDisabled
                                      ? _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.assignTruckWarningTitle"
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                            _vm.getAssignTruckDisabledDetails
                                              .reason1
                                              ? _c("span", [
                                                  _vm._v(
                                                    "· " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignTruckWarning1"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                            _vm.getAssignTruckDisabledDetails
                                              .reason2
                                              ? _c("span", [
                                                  _vm._v(
                                                    "· " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignTruckWarning2"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                            _vm.getAssignTruckDisabledDetails
                                              .reason3
                                              ? _c("span", [
                                                  _vm._v(
                                                    "· " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignTruckWarning3"
                                                        )
                                                      )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.assignToTruck"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                    _c(
                                      "span",
                                      { staticClass: "disabled-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                              disabled:
                                                _vm.isAssignToTruckDisabled ||
                                                _vm.isManualAssignLoading,
                                              loading:
                                                _vm.isManualAssignLoading,
                                            },
                                            on: { click: _vm.assignToTruck },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "truck-moving",
                                                "aria-hidden": "true",
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { staticClass: "d-none d-md-inline-block" },
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { content: _vm.$t("general.save") } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "disabled-btn-wrapper" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled:
                                              !_vm.$anyChanges ||
                                              _vm.isManualAssignLoading,
                                            type: "primary",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.savePlan(_vm.$plan)
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: "save",
                                              "aria-hidden": "true",
                                              size: "lg",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }